export default __webpack_public_path__ + "static/media/Dr-Patrik-Gisel.fd5ac3ba.jpg";